import 'idempotent-babel-polyfill'

import Vue from 'vue'
import vuetify from './plugins/vuetify'
import { VueMaskDirective } from 'v-mask'
import moment from 'moment'

import ApiCall from './utils/api-call'
import App from './App.vue'
import router from './router'
import store from './store'
import urls from './router/urls'

import NDatePicker from '@/components/common/n-date-picker'
import NSignPad from '@/components/common/n-sign-pad'

import './utils/toast'

import 'vuetify/src/styles/main.sass'
import '@/assets/sass/main.scss'

Vue.config.productionTip = false
Vue.prototype.$axios = ApiCall

const getErrorDetails = (e) => {
  const regex = /\((.*):(\d+):(\d+)\)$/
  const stacks = e.stack.split('\n')

  if (stacks.length <= 1) {
    return {
      filepath: 'unknown',
      line: 'unknown',
    }
  }

  const match = regex.exec(e.stack.split('\n')[1])
  if (!match || match.length <= 1) {
    return {
      filepath: 'unknown',
      line: 'unknown',
    }
  }

  let filepath = match[1]
  const srcPos = filepath.indexOf('/src/')

  if (srcPos >= 0) {
    filepath = filepath.substring(srcPos)
  }

  const qmPos = filepath.indexOf('?')
  if (qmPos > 0) {
    filepath = filepath.substring(0, qmPos)
  }

  return {
    filepath,
    line: match[2],
    // column: match[3],
  }
}

Vue.config.errorHandler = async (err, vm, info) => {
  const errComponent = vm && vm.$vnode ? vm.$vnode.tag : 'unknown'
  const errInfo = `Error in ${ info }`
  const errDetails = getErrorDetails(err)

  const params = {
    secret_key: 'lfdksjfdsopi93kfdnsdk§gfrsd',
    client_timestamp: moment().format(),
    message: err.message,
    type: err.name,
    component: errComponent,
    line_nr: `${ errDetails.line }`,
    params: `${ errInfo }: ${ errDetails.filepath }`,
    browser: navigator.userAgent
  }

  await ApiCall.post(urls.SaveError, params)
}

window.addEventListener('unhandledrejection', async (event) => {
  // event.promise contains the promise object
  event.preventDefault()
  const errDetails = getErrorDetails(event.reason)

  const params = {
    secret_key: 'lfdksjfdsopi93kfdnsdk§gfrsd',
    client_timestamp: moment().format(),
    message: event.reason.message,
    type: event.reason.name,
    component: 'promise',
    line_nr: `${ errDetails.line }`,
    params: `${ event.type }: ${ errDetails.filepath }`,
    browser: navigator.userAgent
  }

  await ApiCall.post(urls.SaveError, params)
})

Vue.directive('mask', VueMaskDirective)
Vue.component('n-date-picker', NDatePicker)
Vue.component('n-sign-pad', NSignPad)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
